// App.js

import React, { useState } from "react";
import * as XLSX from "xlsx";
import { getToken, base_url } from "../../config/config";

function UploadBulkRechnung() {
  const [excelData, setExcelData] = useState([]);

  // Function to handle file upload
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (event) => {
      const binaryStr = event.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const data = XLSX.utils.sheet_to_json(sheet);
      setExcelData(data);
    };

    reader.readAsBinaryString(file);
  };

  // Function to send data to the backend
  const handleUploadToBackend = async () => {
    try {
      const response = await fetch(`${base_url}/v1/uploadRechnungs`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(excelData),
      });

      const result = await response.json();
      console.log(result);
    } catch (error) {
      console.error("Error uploading data:", error);
    }
  };

  return (
    <div>
      <h1>Excel to MongoDB</h1>
      <input type='file' onChange={handleFileUpload} />
      <button onClick={handleUploadToBackend}>Upload to Backend</button>

      {/* Display parsed data (for debugging) */}
      <pre>{JSON.stringify(excelData, null, 2)}</pre>
    </div>
  );
}

export default UploadBulkRechnung;
